export default {
    PUT_PRODUCT_TO_CART: 'PUT_PRODUCT_TO_CART_SUCCESS',
    REMOVE_PRODUCT_FROM_CART: 'REMOVE_PRODUCT_FROM_CART_SUCCESS',
    CHANGE_PRODUCT_QUANTITY: 'CHANGE_PRODUCT_QUANTITY_SUCCESS',
    CLEAR_CART: 'CLEAR_CART_SUCCESS'
};
